import React, { useState, useEffect } from 'react'
import { useRecoilState } from 'recoil';
import { Link } from "react-router-dom";
import axios from 'axios';
import { _programlandingdata } from '../RecoilState';
import _ from 'lodash';
import LandingProgramCard from '../components/LandingProgramCard';
import Loader from '../components/Loader';
import SessionGameBanner from '../components/SessionGameBanner';

const ProgramLanding = () => {
    const [programlandingdata, setProgramlandingData] = useRecoilState(_programlandingdata)
    const [groupedprograms, setGroupedprograms] = useState([])
    const [programs, setPrograms] = useState([])
    const [valid, setValid] = useState(false)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        console.log(Object.keys(programlandingdata).length)
        const loaderdata = Object.keys(programlandingdata).length
        if (loaderdata == 0) {
            setValid(false)
        } else {
            getPrograms()
            setValid(true)
        }
    }, [programlandingdata]);

    const getPrograms = () => {
        const cat = _.join(programlandingdata.select_cat_homepage, ',');
        console.log(cat)
        axios.get(`programs?program_category=${cat}&acf_format=standard`)
            .then((response) => {
                groupedData(response.data)
                const reversed = _.reverse(response.data);
                setPrograms(reversed)
                setLoading(false)
                console.log(response.data)
            })
    }

    const groupedData = (data) => {
        // console.log(data)
        const grouped = _.groupBy(data, (item) => item.program_category[0]);
        setGroupedprograms(grouped)
        // console.log(grouped[2])
    }

    return (
        <>
            {
                loading ? <Loader /> :
                    <div>
                        {
                            valid ?
                                <>
                                    {/* page heading */}
                                    {/* <div className='spacer'>
                                        <p className='gradient-heading brand-text'>Growing up with Yancha : Time-tested concepts and expert guidance for institutions and individuals</p>
                                    </div> */}

                                    <div className='spacer'>
                                        <SessionGameBanner />
                                    </div>

                                    {/* page heading */}
                                    <div className='spacer'>
                                        <p className='large-gradient-heading brand-text'>{programlandingdata.program_name_homepage}</p>
                                    </div>

                                    {/* flashcards */}
                                    <div className='spacer flex flex-row flex-wrap -m-2'>
                                        {
                                            programs.map(card => (
                                                <div className='w-1/2'>
                                                    <LandingProgramCard cardinfo={card} />
                                                </div>
                                            ))
                                        }
                                    </div>

                                </>
                                :
                                <>
                                    <p>Oops! Not Found</p>
                                </>
                        }

                    </div>
            }
        </>

    )
}

export default ProgramLanding